<template>
  <div class="flex w-full flex-col">
    <button
      class="flex items-center rounded-md border border-lk-light-gray p-3 text-sm hover:bg-gray-50 md:p-4 md:text-base"
      @click="selected ? emit('unset:product-group') : emit('set:product-group', productGroup)"
    >
      <p class="flex flex-col text-left">
        <span class="font-medium">{{ productGroup.name }}</span>
        <span class="text-xs font-light md:text-sm">SKU: {{ productGroup.sku }}</span>
        <span class="text-xs font-light md:text-sm">Prioridad: {{ productGroup.makerPriority }}</span>
        <span class="text-xs font-light md:text-sm">
          Estado:
          <span
            :class="{
              'text-green-600': productGroup.status === 'active',
              'text-red-600': productGroup.status === 'inactive',
              'text-gray-600': productGroup.status === 'deleted',
            }"
          >
            {{ productGroup.status }}
          </span>
        </span>
      </p>
      <div class="ml-auto flex flex-col items-end">
        <p class="mb-1 text-xs font-light md:text-sm">Atributos configurados:</p>
        <div class="flex flex-wrap gap-1 text-xs">
          <span
            v-if="productGroup.attribute1Type !== 'not_set'"
            class="rounded bg-blue-100 px-2 py-1 text-blue-800"
          >
            {{ getAttributeLabel(productGroup.attribute1Type) }}
          </span>
          <span
            v-if="productGroup.attribute2Type !== 'not_set'"
            class="rounded bg-green-100 px-2 py-1 text-green-800"
          >
            {{ getAttributeLabel(productGroup.attribute2Type) }}
          </span>
          <span
            v-if="productGroup.attribute3Type !== 'not_set'"
            class="rounded bg-purple-100 px-2 py-1 text-purple-800"
          >
            {{ getAttributeLabel(productGroup.attribute3Type) }}
          </span>
        </div>
      </div>
      <p class="ml-4 mr-2 font-light hover:underline">
        {{ selected ? 'ocultar' : 'ver productos' }}
      </p>
    </button>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  productGroup: ProductGroup;
  maker: Maker;
  selectedProductGroup: ProductGroup;
}>();

const emit = defineEmits<{
  (e: 'set:product-group', value: ProductGroup): void;
  (e: 'unset:product-group'): void;
}>();

const selected = computed(() => props.selectedProductGroup.id === props.productGroup.id);

function getAttributeLabel(attributeType: string): string {
  const labels: Record<string, string> = {
    size: 'Talla',
    color: 'Color',
    model: 'Modelo',
  };
  return labels[attributeType] || attributeType;
}
</script>
